import { Route, Routes } from "react-router-dom";
import Project from "./components/developer/Project";
import Developers from "./pages/developers/Developers";
import Customers from "./pages/customers/Customers";
import AllProjects from "./pages/AllProjects";
import AllTeam from "./pages/AllTeam";

function App() {
  return (
    <div className="App min-h-screen flex flex-col items-center justify-center bg-[#F7F9FC] py-10">
      
      <Routes>
        <Route path="/all-projects" element={<AllProjects />} />
        <Route path="/all-teams" element={<AllTeam />} />
        <Route path="/customers/:project" element={<Customers />} />
        <Route path="/developers/:developer" element={<Developers />} />
      </Routes>
      
    </div>
  );
}

export default App;
